import { Modal } from 'mdb-ui-kit';

var share_modal;
var marking_modal;

export function showShareModal(node) {
    if (!this.node || this.node.id != node.id) {
        this.node = node;
    }
    if (!share_modal) {
        const mdl = document.getElementById('share_modal');
        share_modal = new Modal(mdl);
    }
    share_modal.show();
}

export function showMarkingModal(node) {
    if (!this.node || this.node.id != node.id) {
        this.node = node;
    }
    if (!marking_modal) {
        const mdl = document.getElementById('marking_modal');
        marking_modal = new Modal(mdl);
    }
    marking_modal.show();
}
